import "./adminFormField.css";
import { FieldError } from "../FieldError/FieldError";

// Pass `options` as [{value,label}] for the common case, or plain
// <option> children when the list needs a placeholder/optgroup/disabled
// options that don't fit the simple shape.
export const AdminSelect = ({
  label,
  name,
  error,
  hint,
  required,
  id,
  className = "",
  options,
  children,
  ...rest
}) => {
  const fieldId = id || name;
  return (
    <div className={`admin-field ${className}`}>
      {label && (
        <label htmlFor={fieldId} className="admin-field__label">
          {label}
          {required && <span className="admin-field__required">*</span>}
        </label>
      )}
      <select
        id={fieldId}
        name={name}
        className={`admin-field__control ${error ? "admin-field__control--error" : ""}`}
        aria-invalid={Boolean(error)}
        required={required}
        {...rest}
      >
        {options
          ? options.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))
          : children}
      </select>
      {hint && !error && <span className="admin-field__hint">{hint}</span>}
      <FieldError>{error}</FieldError>
    </div>
  );
};
